import clsx from 'clsx'
import { TableHeader, type TableHeaderProps } from 'primitives/table'
import type {
  DataTableInstance,
  DataTableRowData,
  DataTableColumnVirtualizer,
} from '../../types'
import { DataTableHeadRow } from './table-head-row'

interface Props<TData extends DataTableRowData> extends TableHeaderProps {
  columnVirtualizer?: DataTableColumnVirtualizer
  table: DataTableInstance<TData>
}

export const DataTableHead = <TData extends DataTableRowData>({
  columnVirtualizer,
  table,
  ...rest
}: Props<TData>) => {
  const {
    getHeaderGroups,
    options: { enableStickyHeader, layoutMode },
  } = table

  const tableHeadProps = {
    table,
    ...rest,
  }

  const stickyHeader = enableStickyHeader

  return (
    <TableHeader
      {...tableHeadProps}
      className={clsx(
        'bg-background opacity-100 relative',
        layoutMode?.startsWith('grid') ? 'grid' : 'table-row-group',
        stickyHeader && 'sticky top-0 z-[3]',
        tableHeadProps?.className,
        stickyHeader && layoutMode?.startsWith('grid') ? 'sticky' : 'relative',
      )}
    >
      {getHeaderGroups().map((headerGroup) => (
        <DataTableHeadRow
          columnVirtualizer={columnVirtualizer}
          headerGroup={headerGroup as never}
          key={headerGroup.id}
          table={table}
        />
      ))}
    </TableHeader>
  )
}
